// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"0e325149","453":"70534aed","988":"7d42a5ca"}[chunkId] + ".chunk.js";
};